export enum CaseRegionFilterOptions {
    None = 1,
    DeletedCaseRegions = 2
}